import Image from '../../Image';
import AvailabilityMessage from '../../AvailabilityMessage/AvailabilityMessage';
import './TallImageCard.scss';

interface TallImageCardProps {
	title: string;
	link: string;
	image?: string;
	description?: string;
	statusMessage?: {
		iconColor: string;
		message: string;
	};
	subtitles: { icon: string; text: string }[];

	callout: string;
	qualifier?: string;
	note?: string;
}

export default function TallImageCard({
	title,
	link,
	image,
	statusMessage,
	description,
	subtitles,
	callout,
	qualifier,
	note,
}: TallImageCardProps) {
	return (
		<div className="TallImageCard DynamicProduct">
			<a href={link} className="TallImageCard-link">
				<div className="Image Image-ratioContainer TallImageCard-image">
					<picture className="Image-picture">
						<Image className="Image-img" alt={title} src={image} />
					</picture>

					{statusMessage && (
						<AvailabilityMessage
							iconColor={statusMessage.iconColor}
							message={statusMessage.message}
						/>
					)}
				</div>

				<div className="TallImageCard-Details">
					<h3 className="TallImageCard-title ty-b1">{title}</h3>

					<div className="TallImageCard-icon-subtitleList">
						{subtitles.map(({ icon, text }) => (
							<div key={`${icon}-${text}`} className="TallImageCard-icon-subtitleListItem">
								<span className={`icon icon-${icon} TallImageCard-icon`} />
								<span className="TallImageCard-icon-subtitle ty-cc2">{text}</span>
							</div>
						))}
					</div>

					{description && (
						<div
							className="TallImageCard-description ty-b3"
							dangerouslySetInnerHTML={{ __html: description }}
						></div>
					)}

					{callout && (
						<div className="TallImageCard-callout ty-c1">
							{callout}
							{qualifier && <span className="TallImageCard-qualifier ty-cc2">{qualifier}</span>}
							{note && <span className="TallImageCard-note ty-d4">{note}</span>}
						</div>
					)}
				</div>
			</a>
		</div>
	);
}
